export default "__VITE_ASSET__B1H3cNF5__"